export const DOWNLOAD_B1_FORM = gql`
    mutation downloadB1Form($id: Int!) {
        downloadB1Form(id: $id) {
            id
            fileName
            url
        }
    }
`;
